import type {CreateDocumentInput, GetDocumentsResponse, UpdateDocumentInput } from "@montatec/contracts"
import { del, get, patch, post } from "../../lib/fetch"

export const documentsService = {
    get:    async () => await get<GetDocumentsResponse>("/api/providers/templates/documents").then(res => res.data),
    create: async (data: CreateDocumentInput) => await post(`/api/providers/templates/documents`, data),
    update: async (id: number, data: UpdateDocumentInput) => await patch(`/api/providers/templates/documents/${id}`, data),
    delete: async (id: number) => await del(`/api/providers/templates/documents/${id}`)
}